/* eslint-disable */
import axios from 'axios';
import get from 'lodash/get';

const DEFAULT_CLIENT_CONFIG = {
  handleErrors: true,
};

const showErrorNotification = (message = '', store) => {
  store.dispatch({
    type: '@SHELL_ADD_NOTIFICATION',
    payload: {
      id: `http-${Date.now()}`,
      type: 'error',
      message,
    },
  });
};

const createClientWithErrorHandling = (store, loggerResolver) => {
  const client = axios.create();

  // Add a response interceptor
  client.interceptors.response.use(null, (error) => {
    const logger = loggerResolver();
    const msg = get(error, 'response.data.message');

    if (error.toString() === 'Cancel') {
      return Promise.reject(error);
    }

    if ((msg && typeof msg === 'string') || msg instanceof String) {
      showErrorNotification(msg, store);
    } else {
      showErrorNotification('Oops... Something went wrong', store);
    }

    logger.error(error, { originService: 'axios response interceptor' });

    return Promise.reject(error);
  });

  return client;
};

const createHttpClient = (store, loggerResolver) => {
  const axiosWithErrorHandler = createClientWithErrorHandling(store, loggerResolver);
  const httpClient = (config = {}) => {
    const combinedConfig = { ...DEFAULT_CLIENT_CONFIG, ...config };
    return combinedConfig.handleErrors ? axiosWithErrorHandler : axios;
  };

  httpClient.CancelToken = axios.CancelToken;

  return httpClient;
};

export { createHttpClient };
